class RequestCanceledError extends Error {}

export default { RequestCanceledError }
